import TriggerSelectCount from "acl-ui/components/Multiselect/TriggerSelect/TriggerSelectCount/TriggerSelectCount";

class TriggerSelect extends TriggerSelectCount {
  getText() {
    return this.props.statusTitle;
  }
}
export default TriggerSelect;
